/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type CartItems = {
  __typename?: 'CartItems';
  chainId: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type CartsQuery = {
  __typename?: 'CartsQuery';
  items: Array<CartItems>;
};


export type CartsQueryItemsArgs = {
  chainIds: Array<Scalars['String']['input']>;
};

export type DeliverySchedulesQuery = {
  __typename?: 'DeliverySchedulesQuery';
  nearest: Array<NearestDeliverySchedule>;
};


export type DeliverySchedulesQueryNearestArgs = {
  clientCoords?: InputMaybe<Scalars['String']['input']>;
  clientSettlementId?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod: Scalars['String']['input'];
  nearestAcrossChain: Scalars['Boolean']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  productTags?: InputMaybe<Array<Scalars['String']['input']>>;
  slotTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  storeIds: Array<Scalars['String']['input']>;
};

export type DeliverySlot = {
  __typename?: 'DeliverySlot';
  date: Scalars['String']['output'];
  endOrderingTime: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isOpen: Scalars['Boolean']['output'];
  timeRange: Scalars['String']['output'];
};

export type NearestDeliverySchedule = {
  __typename?: 'NearestDeliverySchedule';
  chainId: Scalars['String']['output'];
  slot?: Maybe<DeliverySlot>;
  storeId: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  carts: CartsQuery;
  deliverySchedules: DeliverySchedulesQuery;
  stores: StoresQuery;
  uberProducts: UberProductsQuery;
};

export type Store = {
  __typename?: 'Store';
  chainId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StoresQuery = {
  __typename?: 'StoresQuery';
  list: Array<Store>;
};


export type StoresQueryListArgs = {
  storeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UberProductDetails = {
  __typename?: 'UberProductDetails';
  mainEan: Scalars['String']['output'];
  stores: Array<UberProductStore>;
  tags: Array<Scalars['String']['output']>;
};

export type UberProductStore = {
  __typename?: 'UberProductStore';
  available: Scalars['Boolean']['output'];
  chainId: Scalars['String']['output'];
  ean: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  storeId: Scalars['String']['output'];
};

export type UberProductsQuery = {
  __typename?: 'UberProductsQuery';
  details: UberProductDetails;
};


export type UberProductsQueryDetailsArgs = {
  ean: Scalars['String']['input'];
  storeIds: Array<Scalars['String']['input']>;
  storesAvailable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductRetailerCardsQueryVariables = Exact<{
  chainIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  storeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  deliveryMethod: Scalars['String']['input'];
  clientCoords?: InputMaybe<Scalars['String']['input']>;
  clientSettlementId?: InputMaybe<Scalars['String']['input']>;
  productEan: Scalars['String']['input'];
  productTags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ProductRetailerCardsQuery = { __typename?: 'Query', uberProducts: { __typename?: 'UberProductsQuery', details: { __typename?: 'UberProductDetails', mainEan: string, stores: Array<{ __typename?: 'UberProductStore', chainId: string, storeId: string, available: boolean, price?: number | null, ean: string }> } }, deliverySchedules: { __typename?: 'DeliverySchedulesQuery', nearest: Array<{ __typename?: 'NearestDeliverySchedule', chainId: string, slot?: { __typename?: 'DeliverySlot', id: string, date: string, timeRange: string, endOrderingTime: number, isOpen: boolean } | null }> }, carts: { __typename?: 'CartsQuery', items: Array<{ __typename?: 'CartItems', chainId: string, count: number }> } };


export const ProductRetailerCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductRetailerCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chainIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deliveryMethod"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientCoords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientSettlementId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productEan"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productTags"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uberProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ean"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productEan"}}},{"kind":"Argument","name":{"kind":"Name","value":"storeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"storesAvailable"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainEan"}},{"kind":"Field","name":{"kind":"Name","value":"stores"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chainId"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliverySchedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nearest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nearestAcrossChain"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"storeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"deliveryMethod"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deliveryMethod"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientCoords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientCoords"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientSettlementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientSettlementId"}}},{"kind":"Argument","name":{"kind":"Name","value":"slotTypes"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"open","block":false}]}},{"kind":"Argument","name":{"kind":"Name","value":"productTags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productTags"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chainId"}},{"kind":"Field","name":{"kind":"Name","value":"slot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"timeRange"}},{"kind":"Field","name":{"kind":"Name","value":"endOrderingTime"}},{"kind":"Field","name":{"kind":"Name","value":"isOpen"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"carts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chainIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chainIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chainId"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ProductRetailerCardsQuery, ProductRetailerCardsQueryVariables>;